import React, { Component } from 'react';
import './styles.scss';
import { get, flow } from 'lodash';
import { connect } from 'react-redux';
import { Col, Row, ControlLabel, FormGroup } from 'react-bootstrap';
import { Field, getFormValues, change, resetSection } from 'redux-form';
import {
  Box,
  HorizontalFormControl,
  SimpleCheckbox,
  NameFields,
  SelectBrokerCategory,
  SelectLegalEntityType,
  SelectRole,
  DatePicker,
} from '../../../../../../common/components';
import PostcodeList from '../../../../../../common/components/Postcode/PostcodeList';
import { actions } from '../../../../../brokerApplication/redux/brokerApplicationActions';
import { AddressFields } from '../../../../../../common/components/ReduxFormField';
import { required } from 'redux-form-validators';
import ButtonGroup from '../ReduxFormFields/ButtonGroup';
import { bindActionCreators } from 'redux';
import AsyncSelectMenu from '../../../../../../common/components/SelectMenu/AsyncSelectMenu';

//TODO probably need to refactor this into separate components for editing broker vs broker application
const isRequired = required({ message: 'Required' });

const ATTRIBUTES = 'data.attributes.organisation';

class Company extends Component {
  state = {
    legalEntity: null,
    disableFields: false,
    isExistingBroker: false,
    hasExistingParentOrganisation: undefined,
  };

  componentDidMount() {
    const { existingBroker, formValues } = this.props;
    this.setState({
      isExistingBroker: !!existingBroker,
      hasExistingParentOrganisation: !!(
        formValues && get(formValues, 'data.relationships.organisation.data.id')
      ),
    });
  }

  updateOrganisation() {
    const {
      existingParentOrganisation,
      dispatch,
      change,
      resetSection,
      form,
    } = this.props;
    const organisationPath = existingParentOrganisation
      ? 'data.relationships.organisation.data'
      : ATTRIBUTES;
    if (existingParentOrganisation) {
      change(form, organisationPath, existingParentOrganisation);
      change(
        form,
        'data.attributes.address',
        existingParentOrganisation.attributes.address,
      );
      dispatch(
        change(
          'data.attributes.phone_number',
          existingParentOrganisation.attributes.phone1,
        ),
      );
      if (get(existingParentOrganisation, 'relationships.legal_entity_type.data.id')) {
        dispatch(
          change(
            form,
            'data.relationships.legal_entity_type.data.id',
            existingParentOrganisation.relationships.legal_entity_type.data.id,
          ),
        );
      }
    } else {
      resetSection(form, 'data.attributes.address');
      resetSection(form, 'data.attributes.phone_number');
      resetSection(form, 'data.relationships.organisation.data.address');
    }
  }

  handleFCANumberChange(value) {
    const { change, form, actions } = this.props;
    if (!value) {
      actions.clearExistingOrganisation();
      change(form, 'data.relationships.organisation.data', {});
    } else {
      Promise.resolve(actions.getOrganisationByFCANumber(value)).then(() => {
        this.updateOrganisation();
      });
    }
  }

  handleParentOrganisationSelect = (option) => {
    const { change, form, actions } = this.props;
    if (!option) {
      actions.clearExistingOrganisation();
      change(form, 'data.relationships.organisation.data', {});
    } else {
      Promise.resolve(actions.getOrganisationById(option.value)).then(() => {
        this.updateOrganisation();
      });
    }
  };

  handleTradingAddressSameAsRegisteredAddress(e) {
    const {
      dispatch,
      resetSection,
      change,
      formValues,
      form,
      existingParentOrganisation,
    } = this.props;
    const organisationType = existingParentOrganisation
      ? 'data.relationships.organisation.data.attributes'
      : 'data.attributes.organisation';
    if (!e) {
      dispatch(resetSection(form, 'data.attributes.address'));
      dispatch(resetSection(form, 'data.attributes.phone_number'));
    } else {
      change(
        form,
        'data.attributes.address',
        get(formValues, `${organisationType}.address`),
      );

      // change(
      //   form,
      //   'data.attributes.organisation.phone1',
      //   get(formValues, 'data.attributes.phone_number'),
      // );
    }
  }

  handleHasExistingParentOrganisation(value) {
    const { actions, change, form } = this.props;
    if (!value) {
      actions.clearExistingOrganisation();
      change(form, 'data.relationships.organisation.data', {});
    }
    this.setState({
      hasExistingParentOrganisation: value,
    });
  }

  render() {
    const {
      formValues,
      existingParentOrganisation,
      content,
      form,
      isValidDate,
    } = this.props;
    const { isExistingBroker, hasExistingParentOrganisation } = this.state;
    const organisationPath =
      existingParentOrganisation || isExistingBroker
        ? 'data.relationships.organisation.data.attributes'
        : 'data.attributes.organisation';

    return (
      <Box>
        <Row>
          <Col sm={12}>
            <h4 className="page-title">Company Information</h4>
            <hr />
          </Col>
        </Row>
        {content.fields.map((field) => {
          // Compensate for previous data set using free form input field.
          if (field.name === 'data.attributes.metadata.date_business_established') {
            if (isValidDate()) {
              return (
                <FormGroup
                  controlId={field.name}
                  // className={meta && meta.touched && meta.error ? ' has-error' : ''}
                >
                  <Col sm={3}>
                    <ControlLabel>{field.label}</ControlLabel>
                  </Col>
                  <Col sm={4} md={9}>
                    <Field
                      name={field.name}
                      key={field.name}
                      labelSize={3}
                      fieldSize={4}
                      dateFormat={'dd/MM/yyyy'}
                      component={DatePicker}
                      // validate={[isRequired]}
                      // showMonthYearPicker
                    />
                  </Col>
                </FormGroup>
              );
            } else {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
          }
          switch (field.type) {
            case 'currency': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  currency
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }

            case 'email': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'website': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'select': {
              if (field.selectType === 'brokerCategory') {
                return (
                  <FormGroup key={field.name}>
                    <Col sm={3}>
                      <ControlLabel> {field.label}</ControlLabel>
                    </Col>
                    <Col sm={4}>
                      <Field name={field.name} component={SelectBrokerCategory} />
                    </Col>
                  </FormGroup>
                );
              }
              if (field.selectType === 'role') {
                return (
                  <FormGroup key={field.name}>
                    <Col sm={3}>
                      <ControlLabel> {field.label}</ControlLabel>
                    </Col>
                    <Col sm={4}>
                      <Field
                        name={field.name}
                        component={SelectRole}
                        autoFilters={[{ type: 'name', match: 'Admin (Broker)' }]}
                      />
                    </Col>
                  </FormGroup>
                );
              }
              break;
            }
            case 'input': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }

            case 'number': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'date': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'name': {
              return (
                <NameFields
                  key={field.name}
                  baseName={field.name}
                  label={field.label}
                  labelSize={3}
                />
              );
            }
            case 'question': {
              return (
                <FormGroup key={field.name}>
                  <Col sm={5}>
                    <ControlLabel>{field.label}</ControlLabel>
                  </Col>
                  <Col sm={2}>
                    <div className={'broker-application-answers'}>
                      <Field
                        name={field.name}
                        component={ButtonGroup}
                        inline
                        options={[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ]}
                      />
                    </div>
                  </Col>
                </FormGroup>
              );
            }
          }
        })}

        {!isExistingBroker && hasExistingParentOrganisation !== undefined && (
          <FormGroup>
            <Col sm={8}>
              Does This broker belong to an existing organisation?
              <SimpleCheckbox
                handleChange={(e) => this.handleHasExistingParentOrganisation(e)}
                initialState={hasExistingParentOrganisation}
                inline
              />
            </Col>
          </FormGroup>
        )}

        {hasExistingParentOrganisation && (
          <FormGroup>
            <Col sm={3}>
              <ControlLabel>Existing Organisation</ControlLabel>
            </Col>
            <Col sm={4}>
              <Field
                name={'data.relationships.organisation.data.id'}
                url={'/organisations?'}
                component={AsyncSelectMenu}
                optionValuePath={'id'}
                onChangeCallback={this.handleParentOrganisationSelect}
                autoFilters={[{ type: 'type', match: 'Broker' }]}
              />
            </Col>
          </FormGroup>
        )}
        <Field
          // name={`${organisationPath}.metadata.ico_registration_number`}
          name={'data.attributes.metadata.ico_registration_number'}
          labelSize={3}
          fieldSize={4}
          component={HorizontalFormControl}
          label="ICO Registration Number"
          validate={[isRequired]}
        />
        {!isExistingBroker && (
          <Field
            // name={`${organisationPath}.regulatory_authority_number`}
            name={`${organisationPath}.legal_entity_number`}
            labelSize={3}
            fieldSize={4}
            component={HorizontalFormControl}
            label="FCA Authorisation Number"
            onBlur={(e, value) => this.handleFCANumberChange(value)}
            validate={[isRequired]}
          />
        )}
        {/*{(fcaNumber || hasExistingParentOrganisation) && !isExistingBroker && (*/}
        <div>
          <Field
            name={`${organisationPath}.name`}
            labelSize={3}
            fieldSize={4}
            component={HorizontalFormControl}
            label="Name"
          />

          {/*<Field*/}
          {/*  // name={`${organisationPath}.phone_number`}*/}
          {/*  name={'data.attributes.phone_number'}*/}
          {/*  labelSize={3}*/}
          {/*  fieldSize={4}*/}
          {/*  component={HorizontalFormControl}*/}
          {/*  label="Contact Phone Number"*/}
          {/*  placeholder="Contact Phone Number"*/}
          {/*/>*/}

          <Field
            name={'data.relationships.legal_entity_type.data.id'}
            component={SelectLegalEntityType}
            label={'Type of Company'}
            labelSize={3}
            smFieldSize={4}
          />

          <Field
            // name={`${organisationPath}.legal_entity_number`}
            name={'data.attributes.metadata.company_registration_number'}
            labelSize={3}
            fieldSize={4}
            component={HorizontalFormControl}
            label="Company Registration Number"
          />
          <FormGroup>
            <Col sm={12}>
              <ControlLabel>
                <span className="registered-title">Registered Address</span>
              </ControlLabel>
            </Col>
          </FormGroup>
          <PostcodeList
            adjustWidth
            name={`${organisationPath}.address.postcode`}
            label="Post Code"
            labelSize={3}
            smFieldSize={4}
            formName={form}
            searchSize={2}
            postcodeFieldSize={2}
            targetField={`${organisationPath}.address`}
            value={get(formValues, `${organisationPath}.address.postcode`, '')}
          />
          <AddressFields
            baseName={`${organisationPath}.address`}
            label="Address"
            labelSize={3}
            searchSize={2}
            smFieldSize={4}
            disabled={true}
          />
        </div>
        {/*)}*/}
        <div>
          <FormGroup>
            <Col sm={12}>
              <ControlLabel>
                <span className="registered-title">Trading Address</span>
              </ControlLabel>
            </Col>
          </FormGroup>

          {!isExistingBroker && (
            <FormGroup>
              <Col sm={8}>
                Is The Trading Address the same as the Registered Address?
                <SimpleCheckbox
                  handleChange={(e) =>
                    this.handleTradingAddressSameAsRegisteredAddress(e)
                  }
                  initialState={!!existingParentOrganisation}
                  inline
                />
              </Col>
            </FormGroup>
          )}

          <PostcodeList
            adjustWidth
            name={'data.attributes.address.postcode'}
            label="Post Code"
            labelSize={3}
            postcodeFieldSize={2}
            searchSize={2}
            smFieldSize={4}
            formName={form}
            value={get(formValues, 'data.attributes.address.postcode', '')}
            targetField="data.attributes.address"
          />
          <AddressFields
            baseName={'data.attributes.address'}
            label="Address"
            labelSize={3}
            smFieldSize={4}
          />
          <Field
            name={'data.attributes.organisation.phone1'}
            label="Trading Phone Number"
            placeholder="Trading Phone Number"
            labelSize={3}
            fieldSize={4}
            component={HorizontalFormControl}
          />
        </div>
      </Box>
    );
  }
}

// const form = reduxForm()(Company)
// const mapStateToProps = (state, props) => {
//
//   return {
//     //auth: state.auth,
//     existingParentOrganisation: state.brokerApplication.existingParentOrganisation,
//     isSubmitting: state.brokerApplication.isFetching,
//     initialValues: props.resource,
//     form: props.form,
//     formValues: getFormValues(props.form)(state),
//     destroyOnUnmount: false,
//     forceUnregisterOnUnmount: true,
//
//   }
// }
//
// export default connect(mapStateToProps)(form)

export default flow([
  connect(
    (state, props) => {
      return {
        formValues: getFormValues(props.form)(state),
        existingParentOrganisation: state.brokerApplication.existingParentOrganisation,
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(actions, dispatch),
      change: bindActionCreators(change, dispatch),
      resetSection: bindActionCreators(resetSection, dispatch),

      dispatch,
    }),
  ),
])(Company);
